module.exports = __webpack_public_path__ + "static/img/newimg7.4c19150.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/newimg7.png
// module id = 0Ss0
// module chunks = 1